import { render, staticRenderFns } from "./PropostaDetalhamento.vue?vue&type=template&id=3dbc95af&"
import script from "./PropostaDetalhamento.vue?vue&type=script&lang=js&"
export * from "./PropostaDetalhamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports